// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const dashboard = [
  {
    path: '/dashboard/:perfil',
    name: 'dashboard',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/dashboards/General.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
    },
  },
]

export default dashboard
